export default function Testimonial() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left: Image */}
          <div className="lg:w-[42%] w-full">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] max-w-md mx-auto lg:max-w-none">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20professional%20woman%20in%20cream%20blazer%20holding%20tablet%20smiling%20genuinely%20in%20bright%20airy%20loft%20space%2C%20natural%20daylight%20from%20skylight%2C%20modern%20editorial%20portrait%20photography%2C%20warm%20neutral%20interior%20with%20plants%2C%20confident%20relaxed%20pose%2C%20soft%20professional%20aesthetic&width=800&height=1000&seq=testimonial-user-v2&orientation=portrait"
                alt="Verified ACBuy Spreadsheet user review"
                title="ACBuy Spreadsheet user testimonial"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:w-[58%] w-full">
            <span className="inline-block text-xs font-semibold tracking-widest text-primary-600 uppercase mb-6">
              (Verified Review)
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-8">
              Loved by <span className="text-foreground-400">2,000+</span> Users
            </h2>
            <blockquote className="text-lg md:text-xl text-foreground-600 leading-relaxed italic mb-8 border-l-4 border-primary-300 pl-6">
              "I used to spend hours jumping between different sites just to compare a few sneakers. Since discovering
              the acbuy spreadsheet, my entire shopping workflow changed overnight. Everything is organized, prices are
              updated daily, and I can track items across all fourteen categories without opening a dozen tabs. It is
              honestly the most underrated shopping tool out there right now."
            </blockquote>
            <p className="text-sm font-semibold text-foreground-900">
              &mdash; Alex R., Trend Hunter &amp; Early Adopter
            </p>

            {/* Navigation dots */}
            <div className="flex items-center gap-3 mt-10">
              <button className="w-10 h-10 rounded-full border border-foreground-300 flex items-center justify-center hover:border-foreground-600 transition-colors duration-200 cursor-pointer">
                <i className="ri-arrow-left-line text-foreground-500"></i>
              </button>
              <button className="w-10 h-10 rounded-full bg-foreground-900 flex items-center justify-center hover:bg-foreground-800 transition-colors duration-200 cursor-pointer">
                <i className="ri-arrow-right-line text-background-50"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}